const NT_CONFIG = {
  buttonId: "bss-b2b-net-term-button",
  wrapperId: "bss-b2b-net-term-button-wrapper",
  checkoutSelector: '[name="checkout"]',
  drawerOpenClass: "drawer-open",    
  cartContainers: [
    "cart-drawer",
    "#CartDrawer",
    ".drawer",
    "body" 
  ]
};


function initNTIfReady(){
  if (BSS_B2B?.nt?.initFunction) {
    BSS_B2B.nt.initFunction();
    document.dispatchEvent(new Event("DOMContentLoaded"));
  }
}

function syncWrapperVisibility(){
  const wrap = document.getElementById(NT_CONFIG.wrapperId);
  if(!wrap) return;

  const btn = document.getElementById(NT_CONFIG.buttonId);
  const checkout = document.querySelector(NT_CONFIG.checkoutSelector);

  const hideWrap = () => {
    wrap.classList.add("hide-wrapper");
    if(checkout) checkout.classList.remove("hide-wrapper");
  };

  const showWrap = () => {
    wrap.classList.remove("hide-wrapper");
    if(checkout) checkout.classList.add("hide-wrapper");
  };

  if(!btn){
    hideWrap();
    return;
  }

  const isHidden = getComputedStyle(btn).display === "none";

  if(isHidden){
    hideWrap();
  }else{
    showWrap();
  }
}



function findCartRoot(){
  for(const sel of NT_CONFIG.cartContainers){
    const el = document.querySelector(sel);
    if(el) return el;
  }
  return document.body;
}

const bodyObserver = new MutationObserver(() => {
  if (document.body.classList.contains(NT_CONFIG.drawerOpenClass)) {
    setTimeout(() => {
      initNTIfReady();
      syncWrapperVisibility();
    }, 300);
  }
});

bodyObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['class']
});


const cartObserver = new MutationObserver(() => {
  initNTIfReady();
  syncWrapperVisibility();
});

const cartRoot = findCartRoot();

cartObserver.observe(cartRoot, {
  childList: true,
  subtree: true
});


setTimeout(() => {
  initNTIfReady();
  syncWrapperVisibility();
}, 800);
